import React, { useEffect } from 'react';

import { BulkEditIssueView } from '../bulk-work-create-common/BulkEditIssueView';
import { BulkConfigureView } from '../bulk-work-create-configure/BulkConfigureView';
import { useAiBulkFetchIssuesList } from '../../services/useAiBulkFetchIssuesList';
import { BulkCreateFlagsContainer } from '../bulk-work-create-common/BulkCreateFlagsContainer';
import { useBulkCreateLoggingEvents } from '../../utils/useBulkCreateLoggingEvents';

import { AiBulkDefaultView } from './AiBulkDefaultView';
import { useGetIssueTypeFields } from '../../services/useGetIssueTypeFields';

export const AiBulkNavigationContainer = ({ onClose }: { onClose: () => void }) => {
	const { logAiInteractionInitiated } = useBulkCreateLoggingEvents();
	useGetIssueTypeFields();

	useEffect(() => {
		logAiInteractionInitiated();
	}, [logAiInteractionInitiated]);

	useAiBulkFetchIssuesList();

	return (
		<>
			<AiBulkDefaultView onClose={onClose} />
			<BulkConfigureView />
			<BulkEditIssueView />
			<BulkCreateFlagsContainer />
		</>
	);
};
